// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"b82b235d","474":"99a4b2a9"}[chunkId] + ".chunk.js";
};